export default "__VITE_ASSET__BkEa24uV__"